import React, { useCallback, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import Platform from 'platform';
import keys from 'config/keys';

const mapStateToProps = ({ modal, overlay, loader, EPGWidget }) => ({
  isSomeOverlayOpen: !!modal.modalType || overlay.show || loader.isLoading || EPGWidget.isVisible,
});

export default function withBackSupport(WrappedComponent) {
  const WithBackSupport = (props) => {
    const { isSomeOverlayOpen } = props;
    const history = useHistory();
    const match = useRouteMatch();
    const isRootPage = match.path === '/';

    const onKeydown = useCallback(
      (e) => {
        if (isSomeOverlayOpen || isRootPage || e.keyCode !== Platform.getKeyCode(keys.BACK)) return;
        e.preventDefault();
        history.goBack();
      },
      [isSomeOverlayOpen, isRootPage, history],
    );

    useEffect(() => {
      document.addEventListener('keydown', onKeydown, true);
      return () => document.removeEventListener('keydown', onKeydown, true);
    }, [onKeydown]);

    return <WrappedComponent {...props} />;
  };

  return connect(mapStateToProps)(WithBackSupport);
}
